/* eslint-disable no-console */
import axios from 'axios'
import { responseHandler, apiErrorHandler } from '../actions/handlers.action'
import { getSettings } from '../actions/settings.action'
import { getStartupDataAction } from './../actions/startup.action'
import get from 'lodash/get'
import { configureJsonLog, setSystemDetails, setTokenInfo, setUserInfo } from 'dxp-ui-logger'
import { isNewTabDetailSession, mapStartupData } from '../helpers/util'
import isEmpty from 'lodash/isEmpty'
import packageJson from '../../package.json'

export const getSettingsData = () => (dispatch, getState ) => {
  return axios({
    headers: {
    'Content-Type': 'application/json',
     Authorization:`basic ${get(window, '__APP_ENV__.BASIC_TOKEN')}`,
     Accept:'application/json',
    },
    method: 'GET',
    url:'/uiconfig'
  }).then(response => {
      let startupData = {}
      if (!isEmpty(get(response, 'data', {}))) {
        startupData = mapStartupData(
          get(response, 'data.ship.code', ''),
          get(response, 'data.visitorMediaGroupId', ''),
          get(response, 'data.url.path', {})
        )
      }
      dispatch(getStartupDataAction({ data: startupData }))
      responseHandler(dispatch, response, getSettings)
      const state = getState()
      const loggingMode = get(state, 'settings.loggingMode', 'info')
      const token = `${get(state, 'auth.tokenDetail.tokenType', {})} ${get(
        state,
        'auth.tokenDetail.accessToken',
        {}
      )}`
      setSystemDetails()
      let currentVersion=get(packageJson, 'version', '')
      let currentComponentName = get(packageJson, 'name', '')
      if (!isNewTabDetailSession()) {
        configureJsonLog(
          get(state, 'startup.logURL'),
          loggingMode,
          token,
          currentComponentName,
          currentVersion
        )
      }
      setTokenInfo(token)
      setUserInfo(token)
      return response
    })
    .catch(function(err) {
      apiErrorHandler(dispatch, err)
    })
}